import React from 'react'
import { CurrenciesIcon } from '../assets/currencies'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import { connect } from 'react-redux'
import { deleteFund, editFund } from '../actions/fund'
import * as selectors from 'selectors'
import { capitalize } from 'lodash'
import Amount from 'components/Amount'
import * as dialogActions from 'actions/dialog'
import EditIcon from 'material-ui-icons/Edit'
import DeleteIcon from 'material-ui-icons/Delete'
import IconButton from 'material-ui/IconButton'

const styles = theme => ({
  root: {
    position: 'relative',
    '&:hover $visibleOnHover': {
      display: 'flex',
    },
  },
  title: {
    display: 'flex',
  },
  icon: {
    paddingRight: 10,
  },
  visibleOnHover: {
    display: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 35,
    justifyContent: 'flex-end',
  },
})

const Fund = ({
  classes,
  fund,
  handleDelete,
  mainCurrency,
  handleEdit,
  cryptocurrencies,
}) => (
  <Card className={classes.root}>
    <CardActions className={classes.visibleOnHover}>
      <IconButton color="primary" onClick={() => handleDelete(fund)}>
        <DeleteIcon />
      </IconButton>
      <IconButton onClick={() => handleEdit(fund)}>
        <EditIcon />
      </IconButton>
    </CardActions>
    <CardContent>
      <Typography gutterBottom type="display1" className={classes.title}>
        <CurrenciesIcon
          className={classes.icon}
          currency={fund.currency}
          width={40}
          height={40}
        />
        {capitalize(cryptocurrencies[fund.currency]) || fund.currency}
      </Typography>
      <Typography noWrap gutterBottom type="headline">
        {fund.description}
      </Typography>
      <Typography type="body1" noWrap>
        <Amount value={fund.balance} /> {fund.currency} ≈{' '}
        <Amount value={fund.value} mainCurrency />
      </Typography>
    </CardContent>
  </Card>
)

Fund.muiName = 'Card'

const mapStateToProps = state => ({
  mainCurrency: selectors.mainCurrency(state),
  cryptocurrencies: selectors.cryptocurrencies(state),
})
const mapDispatchToProps = dispatch => ({
  handleDelete: fund =>
    dispatch(
      dialogActions.openDialog({
        title: `Deletion`,
        body: `Are you sure ?`,
        action: () => dispatch(deleteFund(fund)),
      })
    ),
  handleEdit: fund => dispatch(editFund(fund)),
})
export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Fund)
)



// WEBPACK FOOTER //
// ./src/components/Fund.js